import { HorizontalNavigationTab } from "@risalabs_frontend_org/oasis-ui-kit";
import { useState } from "react";
import type { MedicaidCoverageInformation } from "../../../../data-model/coverageInformation";
import EvCoverageMedicaidPayerPlan from "./evCoverageMedicaidPayerPlan";
import EvCoverageMedicaidServices from "./evCoverageMedicaidServices";

/** Tab identifiers for the read-only Medicaid coverage view. */
const MEDICAID_TAB = {
  TREATMENT: "treatment",
  PAYER_PLAN: "payerPlan",
} as const;

const MEDICAID_TABS = [
  { value: MEDICAID_TAB.TREATMENT, label: "Treatment" },
  { value: MEDICAID_TAB.PAYER_PLAN, label: "Additional Payer / Payer Plan" },
];

/** Props for {@link EvCoverageMedicaidContent}. */
export interface EvCoverageMedicaidContentProps {
  medicaidInformation: MedicaidCoverageInformation;
}

/**
 * Read-only Medicaid coverage content shown in place of the BV financials.
 *
 * Owns a two-tab navigation: a Treatment tab (covered / non-covered service
 * codes) and an Additional Payer / Payer Plan tab (Third Party Payer + MMC).
 *
 * @param props - The Medicaid coverage display model
 * @returns The tabbed, read-only Medicaid content area
 */
export const EvCoverageMedicaidContent = ({
  medicaidInformation,
}: EvCoverageMedicaidContentProps) => {
  const [activeTab, setActiveTab] = useState<string>(MEDICAID_TAB.TREATMENT);

  return (
    <>
      <div className="w-full min-w-0 shrink-0 overflow-x-auto">
        <HorizontalNavigationTab
          tabs={MEDICAID_TABS}
          value={activeTab}
          onChange={setActiveTab}
          rounded
          className="w-max min-w-full shrink-0 border-b border-primaryGray-15"
          backgroundColor="#fff"
        />
      </div>
      <div className="ev-coverage-unified__financial-scroll min-h-0 flex-1 overflow-y-auto pt-1 [-ms-overflow-style:none] [scrollbar-width:none] md:pt-2 [&::-webkit-scrollbar]:hidden">
        {activeTab === MEDICAID_TAB.TREATMENT ? (
          <EvCoverageMedicaidServices
            coveredServices={medicaidInformation.coveredServices}
            nonCoveredServices={medicaidInformation.nonCoveredServices}
          />
        ) : (
          <EvCoverageMedicaidPayerPlan
            thirdPartyPayer={medicaidInformation.thirdPartyPayer}
            managedCare={medicaidInformation.managedCare}
          />
        )}
      </div>
    </>
  );
};

export default EvCoverageMedicaidContent;
